import DialogTitle from './dialog-title';
export default DialogTitle;
